import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Navigation from "vue-navigation";

Vue.use(Navigation, { router });

import "./assets/styles/theme.less";

Vue.prototype.$EventBus = new Vue();

Vue.config.productionTip = false;

// import("vconsole").then((res) => {
// new res.default();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
// });
